import { render } from "./BasicButton.vue?vue&type=template&id=04aa76c3&scoped=true"
import script from "./BasicButton.vue?vue&type=script&lang=js"
export * from "./BasicButton.vue?vue&type=script&lang=js"

import "./BasicButton.vue?vue&type=style&index=0&id=04aa76c3&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04aa76c3"]])

export default __exports__